import * as actions from "../actionTypes";
import { Fetch } from "../../utilities/misc";
import { store } from "../../store";
import { settings } from "../../settings";

const APP_URL = settings.api_url || `https://185.65.246.79:8001`;

const CUSTOMER_ACCOUNT_PATH = '/api/v1/customer';

export const url = {
  createOrder: `${APP_URL}/api/orders`,
  orderDetails: `${APP_URL}/api/orders`,
  calculateOrderAmount: `${APP_URL}/api/orders/calculate-amount`,
  getDepositAmount: `${APP_URL}/api/orders/calculate-deposit`,
  getCleaners: `${APP_URL}/api/cleaners`,
  getCleanerTime: `${APP_URL}/api/cleaners`,
  getCategories: `${APP_URL}/api/categories`,
  getServices: `${APP_URL}/api/services`,
  queryServices: `${APP_URL}/api/service-search`,
  getUpsells: `${APP_URL}/api/get-upsells`,
  getReviews: `${APP_URL}/api/reviews`,
  getSystemSettings: `${APP_URL}/api/system-settings`,
  checkAddress: `${APP_URL}/api/address/check`,
  checkEmail: `${APP_URL}/api/email/check`,
  disabledDates: `${APP_URL}/api/get-disabled-days`,
  account: {
    auth: {
      sendCode: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/auth/send-code`,
      auth: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/auth`,
      googleAuth: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/auth/google`,
      logout: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/auth/logout`
    },
    profile: {
      me: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/profile`,
      sendPhoneCode: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/profile/send-phone-code`,
      verifyPhone: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/profile/verify-phone`,
    },
    bookings: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/bookings`,
    payments: `${APP_URL + CUSTOMER_ACCOUNT_PATH}/payments`
  }
};

export type serviceItems = {
  services: { id: number; parent_id: undefined; quantity: number }[];
  extra_services: { id: number; parent_id: number; quantity: number }[];
};

export const getSystemSettings = async (params: serviceItems) => {
  return await Fetch(url.getSystemSettings, {
    method: "POST",
    body: JSON.stringify(params)
  }).then(
    async (res) => {
      const result: actions.settings = await res.json();
      store.dispatch({
        type: actions.SET_SYSTEM_SETTINGS,
        payload: result
      });
      return result;
    },
    (error) => {
      throw error;
    }
  );
};

// Store the data with an expiration timestamp of 3 days
export const storeData = (key: string, value: unknown) => {
  const expirationDate = new Date().getTime() + 3 * 24 * 60 * 60 * 1000; // 3 days from now
  const data = { value, expirationDate };
  localStorage.setItem(key, JSON.stringify(data));
};

export const category_cacheKey = "all_categories";

// Retrieve the data and check if it has expired
export const retrieveData = <T extends Object>(key: string): T | null => {
  const storedDataObj = localStorage.getItem(key);
  const data = storedDataObj ? JSON.parse(storedDataObj) : null;

  if (data) {
    if (new Date().getTime() > data.expirationDate) {
      localStorage.removeItem(key); // remove the expired data
      return null;
    }
    return data.value; // return the value if it has not expired
  }
  return null; // return null if the data is not found
};

export type wordpressBarResponse = {
  data: {
    bars: {
      name: string;
      status: boolean;
      style: string;
      html: string;
      js: string;
    }[];
  };
};

export const barCacheKey = "header_bar";
export const getBenefitBarHTML = async ({
  background
}: {
  background?: boolean;
}) => {
  const response = (
    background ? null : retrieveData(barCacheKey)
  ) as wordpressBarResponse | null;

  if (response) return response;
  return await Fetch("https://cleanbee.ie/wp-json/custom/v1/bars").then(
    async (res) => {
      const result: wordpressBarResponse = await res.json();
      storeData(barCacheKey, result);

      return result;
    },
    (error) => {
      throw error;
    }
  );
};
